import { createSlice } from "@reduxjs/toolkit";

// Static dropdown values for various dropdowns

//ManagementUser

// Status
const initialManagementUserStatus = [
  { value: 2, label: "-- ALL --" },
  { value: 1, label: "Active Users" },
  { value: 0, label: "Inactive Users" },
];

//Status
const RadioBtnStatus = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

//RegisteredUser
const initialconnectionOptions = [
  { value: "2", label: "-- Select --" },
  { value: "0", label: "No Connection" },
  { value: "1", label: "Connection" },
];

const initialstatusOptions = [
  { value: "4", label: "-- Select --" },
  { value: "1", label: "Active Users" },
  { value: "0", label: "Inactive Users" },
  { value: "3", label: "Deactivated Users" },
  { value: "2", label: "Pending Users" },
  { value: "5", label: "E-mail Reverification Pending" },
];
const publicUserinitialstatusOptions = [
  { value: 3, label: "-- ALL --" },
  { value: 1, label: "Active Users" },
  { value: 0, label: "Inactive Users" },
  { value: 2, label: "Deactivated Users" },
  { value: 4, label: "E-mail Reverification Pending" },
];

const userStatusOptions = [
  { label: "-- Select --", value: 0 },
  { label: "Active", value: 1 },
  { label: "Inactive", value: 2 },
  { label: "Reactivate", value: 3 },
  { label: "Deactivate", value: 4 },
];

//Login Information options
const LoginTypeopt = [
  { value: 0, label: "User" },
  { value: 1, label: "Admin" },
  { value: 2, label: "All" },
];

//
const AccessPermissionRadio = [
  { value: 1, label: "Enable" },
  { value: 0, label: "Disable" },
];

// Shared
const sharedPodOptions = [
  { value: 2, label: "-- ALL --" },
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];

const podStatusOptions = [
  { value: 2, label: "-- ALL --" },
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];
const dndStatus = [
  { value: 2, label: "Both" },
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

const genderDropdown = [
  { value: 0, label: "-- ALL --" },
  { value: 1, label: "Male" },
  { value: 2, label: "Female" },
];

const getFrequencyOption = [
  {
    label: "-- Select --",
    value: 0,
  },
  {
    label: "Weekly",
    value: 1,
  },
  {
    label: "Monthly",
    value: 2,
  },
];

const getCreditsOption = [
  {
    label: "-- Select --",
    value: 0,
  },
  {
    label: "1.00",
    value: 1,
  },
  {
    label: "2.00",
    value: 2,
  },
  {
    label: "3.00",
    value: 3,
  },
  {
    label: "4.00",
    value: 4,
  },
  {
    label: "5.00",
    value: 5,
  },
  {
    label: "6.00",
    value: 6,
  },
  {
    label: "7.00",
    value: 7,
  },
  {
    label: "8.00",
    value: 8,
  },
  {
    label: "9.00",
    value: 9,
  },
  {
    label: "10.00",
    value: 10,
  },
];

const facilityFrequencyCount = [
  { label: "NA", value: -1 },
  // { label: "0", value: 0 },
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
];

const facilityFrequencyType = [
  { label: "NA", value: -1 },
  { label: "Day", value: 1 },
  { label: "Week", value: 2 },
  { label: "Month", value: 3 },
];

const FacilityInformationmportTypeOption = [
  { value: 1, label: "FTP" },
  { value: 2, label: "Web Service" },
  { value: 0, label: "None" },
];

const DNDInviteType = [
  { value: "Both", label: "Both" },
  { value: "Mobile", label: "Mobile" },
  { value: "Email", label: "Email" },
];

const DNDTypeRadio = [
  { value: "0", label: "Mobile" },
  { value: "1", label: "E-mail" },
];

const DNDType = [
  { value: "Both", label: "Both" },
  { value: "All", label: "All" },
  { value: "Individual", label: "Individual" },
];

const ActiveStatus = [
  { value: 4, label: "-- ALL --" },
  { value: 1, label: "Approved" },
  { value: 2, label: "Rejected" },
  { value: 3, label: "Pending" },
];

//Keywords => Search

const Action = [
  { value: 3, label: "-- ALL --" },
  { value: 0, label: "No Flag" },
  { value: 1, label: "Flag" },
  { value: 2, label: "Quarantine" },
];

const FilterType = [
  { value: 2, label: "-- ALL --" },
  { value: 1, label: "Whole Word" },
  { value: 0, label: "Partial Word" },
];

//Keywords => InsertFiedls
const ActionAdd = [
  { value: 3, label: "-- Select --" },
  { value: 0, label: "No Flag" },
  { value: 1, label: "Flag" },
  { value: 2, label: "Quarantine" },
];

const FilterTypeAdd = [
  { value: 2, label: "-- Select --" },
  { value: 1, label: "Whole Word" },
  { value: 0, label: "Partial Word" },
];

//LogReport
const Alerttype = [
  { value: 0, label: "-- Select --" },
  { value: 1, label: "Less than an Hour" },
  { value: 2, label: "More than an Hour" },
  { value: 3, label: "More than 3 Hours" },
  { value: 4, label: "More than 4 Hours" },
  { value: 5, label: "Not in Use" },
  { value: 6, label: "Less than Half an Hour" },
  { value: 7, label: "More than 24 Hours" },
  { value: 8, label: "More than 24 Hours - Not in Use" },
];

//direction
const direction = [
  { value: 0, label: "-- ALL --" },
  { value: 1, label: "From Inmate" },
  { value: 2, label: "To Inmate" },
];

const flag = [
  { value: 3, label: "-- ALL --" },
  { value: 0, label: "No Flag" },
  { value: 1, label: "Flag" },
  { value: 2, label: "Quarantine" },
];

//Text Search

const matchTypeOptions = [
  { value: 1, label: "Exact Match" },
  { value: 2, label: "Partial Match" },
  { value: 3, label: "Character Pattern Match" },
];

const dateRangeOptions = [
  { value: 1, label: "Last One Month" },
  { value: 2, label: "Last 3 Months" },
  { value: 3, label: "Last 6 Months" },
  { value: 4, label: "Last 1 Year" },
  { value: 5, label: "Custom" },
];

//PaymentReport

const paymentTypeOptions = [
  { value: "All", label: "-- ALL --" },
  { value: "Stripe", label: "Stripe" },
  { value: "PayPal", label: "PayPal" },
  { value: "Google", label: "Google" },
];

const statusOption = [
  { value: 1, label: "Open" },
  { value: 0, label: "Closed" },
  { value: 2, label: "All" },
];

const flagOptions = [
  { value: "0", label: "-- ALL --" },
  { value: "ORANGE", label: "Orange" },
  { value: "RED", label: "Red" },
];

const initiateOptions = [
  { value: 0, label: "Initiate to Single" },
  { value: 1, label: "Initiate to Multi" },
];

const YesOrNoOnly = [
  { value: 1, label: "Yes" },
  { value: 2, label: "No" },
];

const ApproveAction = [
  { value: 1, label: "Approve" },
  { value: 0, label: "Disapprove" },
];

const ReplyMode = [
  { value: 1, label: "By Text" },
  { value: 2, label: "By PDF" },
  { value: 3, label: "By Both" },
];

const RequestStatus = [
  { value: 2, label: "New" },
  { value: 1, label: "Request Opened" },
  { value: 0, label: "Request Closed" },
  { value: 3, label: "-- ALL --" },
];

const UserList = [
  { value: 2, label: "-- ALL --" },
  { value: 0, label: "Inmate" },
  { value: 1, label: "Management User" },
];
//InmateList => Message Tab Flag Dropdown
const Quarantineflag = [
  { value: 3, label: "-- ALL --" },
  { value: 0, label: "No Flag" },
  { value: 1, label: "Flag" },
];

const Quarantineflagfull = [
  { value: 3, label: "-- ALL --" },
  { value: 0, label: "No Flag" },
  { value: 1, label: "Flag" },
  { value: 2, label: "Quarantine" },
];

//InmateList => Debit Tab  => AccType Dropdown

const AccountType = [
  { value: 0, label: "-- Select --" },
  { value: 1, label: "FREE" },
  { value: 2, label: "CACTAS" },
];

const TransactionType = [
  { value: 0, label: "-- Select --" },
  { value: 1, label: "DEBIT" },
  { value: 2, label: "CREDIT" },
];

// InmateList => Message Tab => Request/grievances
const requestType = [
  { value: 1, label: "Visitor Request Form" },
  { value: 2, label: "Administrator Remedy Form" },
  { value: 3, label: "Request Forum Form" },
];

// PostalMailTab
const PMStatus = [
  { value: 0, label: "Pending" },
  { value: 1, label: "Approved" },
  { value: 2, label: "Rejected" },
  { value: 3, label: "-- ALL --" },
];

//InmateInfo Setting

const settingsFrequency = [
  { value: 0, label: "-- Select --" },
  { value: 1, label: "Daily" },
  { value: 2, label: "Weekly" },
  { value: 3, label: "Monthly" },
];

const requestFrequency = [
  { value: -1, label: "NA" },
  { value: 1, label: "Day" },
  { value: 2, label: "Week" },
  { value: 3, label: "Month" },
];

const photoApprovalStatus = [
  { value: 1, label: "Approve" },
  { value: 0, label: "Reject" },
];

const requestStatus = [
  { value: 1, label: "Active" },
  { value: 2, label: "Lock Access" },
];

const monthList = [
  { label: "-- Select --", value: 0 },
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

const eCardViewPermission = [
  { value: 0, label: "-- Select --" },
  { value: 3, label: "Both" },
  { value: 2, label: "Inmate" },
  { value: 1, label: "Public User" },
];
const eCardViewPermissionForRadio = [
  { value: 3, label: "Both" },
  { value: 2, label: "Inmate" },
  { value: 1, label: "Public User" },
];

const EcardReadStatus = [
  { value: 2, label: "Unread" },
  { value: 1, label: "Read" },
  { value: 0, label: "-- ALL --" },
];

const MessageStatus = [
  { value: "0", label: "-- ALL --" },
  // { value: "1", label: "Pending Message Approval" },
  // { value: "2", label: "Message Reject" },
  { value: "3", label: "Read" },
  { value: "4", label: "Unread" },
  { value: "5", label: "Pending Quarantine Approval" },
  { value: "6", label: "Reject Quarantine" },
  { value: "7", label: "C.O.D Message" }
];

// create slice
const name = "dropdowns"; // Generalized name for dropdown management
const initialState = createInitialState();

const slice = createSlice({
  name,
  initialState,
  reducers: {},
});

// exports
export const dropdownActions = {
  ...slice.actions,
};
export const dropdownReducer = slice.reducer;

// implementation
function createInitialState() {
  return {
    managementUserStatus: initialManagementUserStatus,
    Status: RadioBtnStatus,
    connectionOptions: initialconnectionOptions,
    statusOptions: initialstatusOptions,
    publicUserStatusOptions: publicUserinitialstatusOptions,
    userStatusOptions,
    LoginTypeopt,
    AccessPermissionRadio,
    sharedPodOptions: sharedPodOptions,
    podStatusOptions: podStatusOptions,
    dndStatus,
    genderDropdown: genderDropdown,
    getFrequencyOption: getFrequencyOption,
    getCreditsOption: getCreditsOption,
    facilityFrequencyCount: facilityFrequencyCount,
    facilityFrequencyType: facilityFrequencyType,
    FacilityInformationmportTypeOption: FacilityInformationmportTypeOption,
    DNDInviteType: DNDInviteType,
    DNDType: DNDType,
    DNDTypeRadio: DNDTypeRadio,
    ActiveStatus: ActiveStatus,
    Action,
    FilterType,
    ActionAdd,
    FilterTypeAdd,
    Alerttype,
    direction: direction,
    flag: flag,
    matchTypeOptions,
    dateRangeOptions,
    paymentTypeOptions,
    statusOption,
    flagOptions,
    initiateOptions: initiateOptions,
    YesOrNoOnly: YesOrNoOnly,
    ApproveAction: ApproveAction,
    ReplyMode: ReplyMode,
    RequestStatus: RequestStatus,
    UserList: UserList,
    Quarantineflag,
    Quarantineflagfull,
    AccountType,
    TransactionType,
    requestType,
    PMStatus,
    settingsFrequency,
    requestFrequency,
    requestStatus,
    photoApprovalStatus,
    monthList,
    eCardViewPermission,
    eCardViewPermissionForRadio,
    EcardReadStatus,
    MessageStatus,
  };
}
